// @ts-ignore
import packageInfo from '../../package.json';
export const environment = {
  production: true,
  apiUrl: 'https://api-vendor.aclarian.com/api/',
  baseUrl: 'https://slctc.aclarian.com',
  appName: 'St. Lucie County Tax Collector | VendorV2',
  tokenizationKey: 'PaQmTu-VE6uUF-9V6acY-jecjXr',
  datadogClientToken: 'pube62b5f3dc58091a8f362d1a2b33d8bce',
  datadogApplicationId: '5a979d77-789f-4a8f-9295-9dbd027e3eb0',
  datadogService: 'invoicing_slctc_prod',
  ApiKey: 'NdgnZX3k3cyVtJXs',
  env: 'PROD',
  version: packageInfo.version,
};
